import { render, staticRenderFns } from "./BonusCompliance.vue?vue&type=template&id=e3a7f12c"
import script from "./BonusCompliance.vue?vue&type=script&lang=js"
export * from "./BonusCompliance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports